import { defineModule } from '../types.js';
export default defineModule({
    id: 'exercice',
    nom: 'Exécution de l’exercice',
    description: 'Exécution de l’exercice en cours, comparaison d’exercices et détail des écritures.',
    famille: 'exercice',
    dependances: [],
    activableParDefaut: true,
    desactivable: true,
    routesApi: ['/api/ecritures', '/api/atterrissage'],
    droits: {
        'exercice.consulter': { description: 'Consulter l’exécution et le détail des écritures', niveau: 'lecture' },
    },
    navigation: [
        { cle: 'exercice', libelle: 'Exécution {exercice}', picto: '▤', groupe: 'Exercice en cours', ordre: 10, droit: 'exercice.consulter' },
        { cle: 'exercice-compare', libelle: 'Exercice comparé', picto: '⇄', groupe: 'Prévisionnel', ordre: 40, droit: 'exercice.consulter' },
    ],
});
//# sourceMappingURL=exercice.js.map